<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="panelTitle" [description]="" [awesomeIcon]="panelIcon">
    <form class="form-horizontal" (ngSubmit)="onSubmit(formCompanyconfig)"
      #formCompanyconfig="ngForm" novalidate>
      <div class="row">

        <div class="col-sm-12 col-lg-12 mb-2">
            <app-company-selector dataSize="7" placeHolder="Empresas" [(ngModel)]="selectedCompany" name="A3LCompanyCode"
              [onlyConfigured]="true" [required]="true" [disabled]="model && !model.isNew">
            </app-company-selector>
        </div>

        <div class="col-sm-12 col-lg-4">
          <div class="row">
            <!-- <legend>Empleado en IT</legend> -->
            <div class="col-12">
              <ng-container *ngIf="model && model.isNew">
                <app-mat-select-filtered [items]="employeesOnIt" valueColumn="employeeId" [descriptionColumns]="['completeName']" [loading]="loading"
                  [ngModel]="model && model.IdEmpleado" (ngModelChange)="onEmployeeOnItChanged($event)"  placeHolder="Empleado a sustituir" name="IdEmpleado" [required]="true" [emptyOption]="false">
                </app-mat-select-filtered>
              </ng-container>

              <ng-container *ngIf="model && !model.isNew">
                <mat-form-field>
                  <input matInput type="text" [(ngModel)]="model && model.EmpleadoEnIt.A3LCompleteName" name="A3LCompleteName" placeholder="Empleado a sustituir"  disabled/>
                </mat-form-field>
              </ng-container>
            </div>
          </div>
         <div class="row">
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" [ngModel]="model && model.A3LItDescription || employeeOnIt && employeeOnIt.itDescription" name="itDescription" placeholder="Tipo de sustitución"  disabled/>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <mat-form-field>
                <input matInput [ngModel]="employeeOnIt && employeeOnIt.itStartDate || model && model.FechaInicioIt | date:'dd/MM/yyyy'"
                   name="itStartDate" placeholder="Inicio IT" disabled/>
                <mat-datepicker-toggle matSuffix [for]="pickerFechaInicioIT" disabled></mat-datepicker-toggle>
                <mat-datepicker #pickerFechaInicioIT></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <mat-form-field>
                <input matInput  [ngModel]="employeeOnIt && employeeOnIt.itEndDate || model && model.FechaFinIt | date:'dd/MM/yyyy'"
                  name="itEndDate" placeholder="Fin de IT" disabled/>
                <mat-datepicker-toggle matSuffix [for]="pickerFechaFinIT" disabled></mat-datepicker-toggle>
                <mat-datepicker #pickerFechaFinIT></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-lg-4">
          <div class="row">
            <!-- <legend>Sustituto</legend> -->
            <div class="col-12">
              <app-mat-select-filtered [items]="employees" [valueColumn]="'employeeId'" [descriptionColumns]="['completeName']" [loading]="loading"
                [(ngModel)]="model && model.IdEmpleadoSustitucion"  [placeHolder]="'Sustituto'" name="IdEmpleadoSustitucion" [emptyOption]="true" [required]="false">
              </app-mat-select-filtered>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <mat-form-field>
                <input matInput [matDatepicker]="pickerFechaInicio" [(ngModel)]="model && model.FechaInicio"
                   name="FechaInicio" placeholder="Inicio sustitución" [required]="model && model.IdEmpleadoSustitucion"/>
                <mat-datepicker-toggle matSuffix [for]="pickerFechaInicio"></mat-datepicker-toggle>
                <mat-datepicker #pickerFechaInicio></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <mat-form-field>
                <input matInput [matDatepicker]="pickerFechaFin" [(ngModel)]="model && model.FechaFin"
                  name="FechaFin" placeholder="Fin sustitución" />
                <mat-datepicker-toggle matSuffix [for]="pickerFechaFin"></mat-datepicker-toggle>
                <mat-datepicker #pickerFechaFin></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <!-- Botonera -->
      <div class="row">
        <label class="col-md-3"></label>
        <div class="col-md-9">
          <div class="form-group form-button">
            <button class="btn btn-fill btn-primary float-right" type="submit"
              [disabled]="!formCompanyconfig.valid || loading">Guardar</button>
            <a class="btn btn-fill btn-outline-white float-right" routerLink="../">Volver</a>
          </div>
        </div>
      </div>
    </form>
  </app-generic-panel>
</app-generic-container>
